import React from 'react';
import SimpleForm from '../teal-react/components/organisms/SimpleForm';
import { useQuery, useSave } from '../graphql/hooks';

interface TestParameterFormProps {
  model: any;
  onClose: () => void;
}

const TestParameterForm = ({ model, onClose }: TestParameterFormProps) => {
  const save = useSave('product_test_parameter', 'product_test_parameter');
  const { data } = useQuery(`query Specifications{
      specification(order: "name"){
        id
        name
      }
    }`);
  if (!data) {
    return null;
  }
  console.log({ model });
  return (
    <>
      <SimpleForm
        header="Editor"
        model={model}
        cancel={onClose}
        save={(props: any) => {
          const { modified, merged } = props;
          if (!model.id) {
            save(merged, true);
          } else {
            save({
              id: model.id,
              ...modified,
            });
          }
          onClose();
        }}
        fields={[
          {
            name: 'specification_id',
            label: 'Attribute',
            options: data.specification.map((s: any) => ({
              id: s.id,
              value: s.id,
              label: s.name,
            })),
            // disabled: Boolean(model.id),
            validate: { required: true },
            filterable: !Boolean(model.id),
          },
          {
            name: 'parameter',
            label: 'Spec',
            size: 6,
          },
          {
            name: 'coa',
            label: 'COA',
            size: 3,
            options: [
              { label: 'Yes', value: 1 },
              { label: 'No', value: 0 },
            ],
          },
        ]}
      />
    </>
  );
};

export default TestParameterForm;
